import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, SxProps } from '@mui/material';

import { CloseIcon } from '../../../icons';
import { IJoinEventNotificationView } from './interfaces';

import { useStyles as useDefaultNotificationStyle } from '../styles';
import { useStyles } from './styles';

const JoinEventNotificationView = React.forwardRef<
  HTMLDivElement,
  IJoinEventNotificationView
>(
  (
    { message, color, background, isTheme, icon: Icon, onJoin, onClickClose },
    ref,
  ) => {
    const classes = useDefaultNotificationStyle({
      color,
      background,
      title: '',
      isTheme,
    });
    const officeHoursClasses = useStyles({ color });
    const { t: translate } = useTranslation('common');

    if (isTheme) {
      return (
        <Box
          ref={ref}
          sx={{ ...classes.root, ...officeHoursClasses.root } as SxProps}
        >
          <CloseIcon sx={classes.closeIcon} onClick={onClickClose} />
          <Typography sx={classes.message}>{message}</Typography>
          <Box sx={officeHoursClasses.buttonsContainer}>
            <Button sx={officeHoursClasses.button} onClick={onJoin}>
              {translate('ek.officeHours.option.join')}
            </Button>
          </Box>
        </Box>
      );
    }

    return (
      <Box ref={ref} sx={classes.root}>
        <CloseIcon sx={classes.closeIcon} onClick={onClickClose} />
        <Box sx={classes.titleContainer}>
          {Icon ? <Icon sx={classes.icon} /> : null}
          <Typography sx={classes.title}>{message}</Typography>
        </Box>
        <Box sx={classes.buttonsContainer}>
          <Button sx={officeHoursClasses.button} onClick={onJoin}>
            {translate('ek.officeHours.option.join')}
          </Button>
        </Box>
      </Box>
    );
  },
);

export default JoinEventNotificationView;
